<!-- Eikra Footer — 4-column: Logo+About | Featured Links | Information | Newsletter -->
<footer class="footer-top-area">
  <div class="container">
    <div class="row">

      <!-- Col 1: Logo + About + Social -->
      <div class="col-lg-3 col-md-6 col-12 footer-col">
        <div class="widget widget_rdtheme_about">
          <h3 class="widgettitle">
            <img [src]="contact_info?.LogoUrl || 'assets/img/rs-shapes/logo-white.webp'" alt="Logo" class="footer-logo">
          </h3>
          <p class="rtin-des">
            {{contact_info?.InstituteName || 'Our Institution'}} is dedicated to providing quality education and
            fostering excellence for future generations of leaders.
          </p>
          <ul class="footer-social-list">
            <li><a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a></li>
            <li><a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a></li>
            <li><a href="#" aria-label="YouTube"><i class="fab fa-youtube"></i></a></li>
            <li><a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a></li>
            <li><a href="#" aria-label="Instagram"><i class="fab fa-instagram"></i></a></li>
          </ul>
        </div>
      </div>

      <!-- Col 2: Featured Links -->
      <div class="col-lg-3 col-md-6 col-12 footer-col">
        <div class="widget widget_nav_menu">
          <h3 class="widgettitle">Featured Links</h3>
          <ul id="menu-featured-links" class="menu">
            <li><a routerLink="/">Home</a></li>
            <li><a routerLink="/notice-board">Notice Board</a></li>
            <li><a routerLink="/news-and-events">News &amp; Events</a></li>
            <li><a routerLink="/achievements">Achievements</a></li>
            <li><a routerLink="/administration">Administration</a></li>
            <li><a routerLink="/photos">Photo Gallery</a></li>
            <li><a routerLink="/videoFolder">Video Gallery</a></li>
            <li><a routerLink="/contact">Contact Us</a></li>
          </ul>
        </div>
      </div>

      <!-- Col 3: Information (contact with icons) -->
      <div class="col-lg-3 col-md-6 col-12 footer-col">
        <div class="widget widget_rdtheme_info">
          <h3 class="widgettitle">Information</h3>
          <ul>
            <li *ngIf="contact_info?.Address">
              <i class="fas fa-map-marker-alt"></i>
              <span>{{contact_info.Address}}</span>
            </li>
            <li *ngIf="!contact_info?.Address">
              <i class="fas fa-map-marker-alt"></i>
              <span>Bangladesh</span>
            </li>
            <li *ngIf="contact_info?.Phone">
              <i class="fas fa-phone-alt"></i>
              <a [href]="'tel:' + contact_info.Phone">{{contact_info.Phone}}</a>
            </li>
            <li *ngIf="contact_info?.Email">
              <i class="fas fa-envelope"></i>
              <a [href]="'mailto:' + contact_info.Email">{{contact_info.Email}}</a>
            </li>
            <li>
              <i class="fas fa-globe"></i>
              <a routerLink="/">{{contact_info?.InstituteName || 'Our Institution'}}</a>
            </li>
          </ul>
          <div class="footer-quick-links">
            <h4>Quick Links</h4>
            <ul class="quick-link-list">
              <li><a target="_blank" rel="noopener" href="https://moedu.gov.bd/">Ministry of Education</a></li>
              <li><a target="_blank" rel="noopener" href="http://www.educationboard.gov.bd/">Education Board</a></li>
              <li><a target="_blank" rel="noopener" href="https://www.nu.ac.bd/">National University</a></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Col 4: Newsletter / Map -->
      <div class="col-lg-3 col-md-6 col-12 footer-col">
        <div class="widget widget_newsletter">
          <h3 class="widgettitle">Our Location</h3>
          <div class="footer-map-wrap">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2626.2858113847224!2d91.12814787352389!3d23.43901530066281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x37547c260bc902e9%3A0x9be13436af366b91!2sCantonment%20Board%20Secondary%20School!5e1!3m2!1sen!2sbd!4v1789015432555!5m2!1sen!2sbd"
              width="100%" height="160" style="border:0;" allowfullscreen="" loading="lazy"
              referrerpolicy="strict-origin-when-cross-origin" title="Location Map">
            </iframe>
          </div>
          <div class="footer-newsletter">
            <p>Stay updated with latest notices and news from our institution.</p>
            <div class="newsletter-form">
              <input type="email" placeholder="Your email address" class="newsletter-input">
              <button type="button" class="newsletter-btn">Subscribe</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</footer>

<!-- Footer Bottom -->
<div class="footer-bottom-area">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-10 col-md-8 col-12">
        <p style="font-size: 14px;">&copy; Copyright {{currentYear}} <strong>{{contact_info?.InstituteName ||
            'Cantonment Board Mahyamik Bidyalaya'}}</strong>. All Rights Reserved. Designed &amp; Developed by <a
            href="https://deshuniversal.com/" target="_blank" rel="noopener">Desh Universal Pvt. Limited</a></p>
      </div>
      <div class="col-lg-2 col-md-4 col-12 text-end">
        <ul class="footer-bottom-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a routerLink="/notice-board">Notice</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>